import { Map as IMap } from 'immutable';

export const selectModalVisibility = (state) => state.companyColorPalette.get('modalColorPaletteVisible', false);
export const selectCompanyLogo = (state) => state.companyColorPalette.get('companyLogoUrl', '');
export const selectTestimonialUserImage = (state) => state.companyColorPalette.get('uploadedImage', IMap());
export const selectAboutCompanyImage = (state) => state.companyColorPalette.get('uploadedAboutCompanyImage', IMap());
export const selectNewProductDemandImage = (state) => state.companyColorPalette.get('uploadedNewProductDemandImage', IMap());
